const translations = {
  "en": {
    "Delete portfolio": "Delete portfolio",
    "Edit portfolio": "Edit portfolio"
  },
  "zh-tw": {
    "Delete portfolio": "刪除投資組合",
    "Edit portfolio": "編輯投資組合"
  }
};

export default translations;
